export default function LoadingBalls({ width=100, color="#1F2429" }: { width?: number, color?: string }) {
    return (
        <div className="flex justify-between" style={{width: `${width}px`}}>
            <div className="rounded-full bg-primary animate-ball1" style={{width: `${width/10}px`, height: `${width/10}px`, backgroundColor: color}}></div>
            <div className="rounded-full bg-primary animate-ball2" style={{width: `${width/10}px`, height: `${width/10}px`, backgroundColor: color}}></div>
            <div className="rounded-full bg-primary animate-ball3" style={{width: `${width/10}px`, height: `${width/10}px`, backgroundColor: color}}></div>
        </div>
    )
}
